// extracted by mini-css-extract-plugin
export var changeIcon = "_41-4";
export var container = "_41-0";
export var divider = "_41-7";
export var externalLinkIcon = "_41-1";
export var green = "_41-5";
export var helpCircleIcon = "_41-3";
export var iconButton = "_41-2";
export var red = "_41-6";